// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"panel__wrapper___v2ucU","trigger":"panel__trigger___DRteM"};